import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import QuestionnaireDecoder from "@shared/components/QuestionnaireDecoder";

const FeedbackDetailsModal = ({ show, onHide, feedbackDetails }) => {
  const { t } = useTranslation();

  if (!feedbackDetails) {
    return null;
  }

  // Parse answers if it's a string
  let parsedAnswers = {};
  try {
    parsedAnswers = typeof feedbackDetails.answers === 'string' 
      ? JSON.parse(feedbackDetails.answers) 
      : feedbackDetails.answers || {};
  } catch (error) {
    console.error("Error parsing answers:", error);
    parsedAnswers = {};
  }

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {feedbackDetails.template?.name || t("questionnaires.feedbackDetails")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {feedbackDetails.template?.content ? (
          <QuestionnaireDecoder
            content={feedbackDetails.template.content}
            readOnly={true}
            answers={parsedAnswers}
          />
        ) : (
          <div className="text-center text-muted">
            <p>{t("questionnaires.noTemplateData")}</p>
          </div>
        )}
        <div className="mt-3 text-muted small">
          <strong>{t("common.submittedAt")}:</strong>{" "}
          {new Date(feedbackDetails.created_at).toLocaleString()}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t("common.close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FeedbackDetailsModal;
